<template>
  <div id="loyout" @click.capture="hideAside">
    <layoutHeader></layoutHeader>
    <el-container>
      <layoutAside></layoutAside>
      <el-container>
        
        <el-main id="elmain">
            <tabNav></tabNav>
          <transition name="main" mode="out-in">
            <router-view></router-view>
          </transition>
        </el-main>
        <el-footer class="footer">
          <Bottom></Bottom>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import tabNav from "./header/tabNav";
  import layoutAside from './aside/aside'
  import layoutHeader from './header/header'
  import Bottom from './Footer/bottom'
  import langSelect from '../../components/lang/langSelect'

  export default {
    name: 'dc-home',
    components: {
      layoutHeader,
      Bottom,
      langSelect,
      layoutAside,
      tabNav
    },
    methods:{
        hideAside(e){
            if(e &&e.length){
              e.path.forEach(item => {
                if(item.className == 'el-main'){
                    this.$store.state.menuIsShow = false;
                }
            });
            }
        }
    },
    created () {
      this.$router.push('/index');
    }
  }
</script>

<style>
  .main-enter, .main-leave-to {
    opacity: 0;
    transform: translateY(30px);

  }
  .main-enter-active {
    transition: all 0.2s;
  }
  .main-leave-active {
    position: absolute;
    transition: all 0.3s;
  }
  .cardchartshodow, .cardshodow, .card, #maintable{
      padding: 20px;
      box-shadow:0px 0px 20px 10px rgba(168, 168, 168, 0.2) !important;
      -webkit-box-shadow:0px 0px 20px 10px rgba(168, 168, 168, 0.2) !important;
  }
</style>
<style lang="scss">
  * {
    margin: 0px;
    padding: 0px;
  }

  body {
    background-color: #f2f2f2;
    font-size: 14px;
    color: #333333;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  $top: top;
  $bottom: bottom;
  $left: left;
  $right: right;
  $leftright: ($left, $right);
  %w100 {
    width: 100%;
  }

  %h100 {
    height: 100%;
  }

  %cursor {
    cursor: pointer;
  }

  html, body, #loyout, .el-container, #asideNav, ul.el-menu {
    @extend %h100;
  }
  @media screen and (max-width: 1366px) {
  }
  // @mixin set-value($side, $value) {
  //   @each $prop in $leftright {
  //     #{$side}-#{$prop}: $value;
  //   }
  // }

  #elmain {
    background-color:white;
    padding-top:0;
    flex: 7;
  }
.footer{
    flex: 1;
    background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue